export interface IElementAction {
    property: string;
    action: string;
}
